import {normalizeValueSeparator, separatorRegex} from './normalizeSeparators';

export const parseCompactDate = (
    value: string,
    dateFormat: string,
): string | null => {
    // Skip if format includes text-based month/day names
    if (/(M{3,}|E{3,}|Q{3,})/i.test(dateFormat)) {
        return null;
    }

    const normalizedValue = value.replace(separatorRegex, '');

    if (!/^\d+$/.test(normalizedValue)) {
        return null;
    }

    const formatWithoutSeparators = dateFormat.replace(separatorRegex, '');

    if (normalizedValue.length !== formatWithoutSeparators.length) {
        return null;
    }

    return normalizeValueSeparator(normalizedValue, dateFormat);
};
